export var ResourceInitiatorTypes;
(function (ResourceInitiatorTypes) {
    ResourceInitiatorTypes["Media"] = "media";
    ResourceInitiatorTypes["Script"] = "script";
    ResourceInitiatorTypes["Css"] = "css";
    ResourceInitiatorTypes["Beacon"] = "beacon";
    ResourceInitiatorTypes["Img"] = "img";
    ResourceInitiatorTypes["Font"] = "font";
    ResourceInitiatorTypes["Doc"] = "doc";
    ResourceInitiatorTypes["Xhr"] = "xmlhttprequest";
    ResourceInitiatorTypes["Fetch"] = "fetch";
    ResourceInitiatorTypes["Iframe"] = " iframe";
    ResourceInitiatorTypes["Video"] = "video";
    ResourceInitiatorTypes["Audio"] = "audio";
    ResourceInitiatorTypes["Track"] = "track";
    ResourceInitiatorTypes["Other"] = "other";
})(ResourceInitiatorTypes || (ResourceInitiatorTypes = {}));
//# sourceMappingURL=instrumentation.model.js.map